import { Link } from 'react-router-dom';

const infoRows = [
  { label: '剧名', value: '女友的妈妈' },
  { label: '类型', value: '家庭 / 都市 / 情感' },
  { label: '集数', value: '全 12 集（已完结）' },
  { label: '首播', value: '2024-03-05' },
  { label: '导演', value: '沈亦航' },
  { label: '编剧', value: '周晚棠 / 林澈' },
];

export default function DramaInfoCard() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="px-5 py-4 border-b border-background-200 bg-background-100">
        <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <i className="ri-information-line text-primary-600"></i>
          剧集档案
        </h2>
      </div>
      <div className="p-5">
        <div className="flex gap-4">
          <div className="relative w-24 h-[136px] rounded-md overflow-hidden shrink-0 bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20modern%20Chinese%20family%20drama%2C%20a%20mother%20and%20daughter%20standing%20together%20in%20soft%20window%20light%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20artistic%20stylized%20composition%20with%20strong%20contrast%2C%20cinematic%20depth%20of%20field%2C%20refined%20editorial%20poster%20photography&width=480&height=680&seq=drama-poster-2024&orientation=portrait"
              alt="女友的妈妈 电视剧海报"
              title="女友的妈妈 剧集档案 海报"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <dl className="flex-1 min-w-0 space-y-2 text-sm">
            {infoRows.map((row) => (
              <div key={row.label} className="flex gap-3">
                <dt className="text-foreground-500 shrink-0 w-10">{row.label}</dt>
                <dd className="text-foreground-800 truncate">{row.value}</dd>
              </div>
            ))}
          </dl>
        </div>
        <Link
          to="/about"
          className="mt-5 flex items-center justify-center gap-1.5 w-full py-2.5 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 text-sm whitespace-nowrap transition-colors cursor-pointer"
        >
          了解本站
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}